import { render } from "./OtherPicks.vue?vue&type=template&id=c16ba362"
import script from "./OtherPicks.vue?vue&type=script&lang=js"
export * from "./OtherPicks.vue?vue&type=script&lang=js"

import "./OtherPicks.vue?vue&type=style&index=0&id=c16ba362&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__